module.exports = __webpack_public_path__ + "img/Koller.58a5b6b.svg";